import { useEffect, useState, useRef } from "react";
import Breadcrumb from "../../components/Breadcrumb";
import SingleProgress from "../../components/Progress";
import Men from "../../assets/img/men.jpg";
import avatarImg from "../../assets/img/logo/loading-img.png";
import { TabPanel, Tabs } from "react-tabs";
import defualt from "../../assets/img/admin/defualt.png";

const getSocialIcon = (url) => {
  if (!url) return "fa-regular fa-globe";
  if (url.includes("facebook.com")) return "fab fa-facebook";
  if (url.includes("twitter.com")) return "fab fa-twitter";
  if (url.includes("linkedin.com")) return "fab fa-linkedin";
  if (url.includes("instagram.com")) return "fab fa-instagram";
  return "fa-regular fa-globe";
};

const formatDate = (dateString) => {
  if (!dateString) return "NA";
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "NA";
  return date
    .toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    })
    .replace(/\//g, "-");
};

const MemberProfileCardMain = ({ member, leadershipRole }) => {
  const rolesData =
    leadershipRole?.roles?.map((role, index) => {
      let roleName = role.designationId?.name || "";

      return {
        sno: index + 1,
        role: roleName,
        period: `${role.from}–${role.to}`,
      };
    }) || [];
  const initialFormData = {
    profileInfo: {
      title: "Mr.",
      firstName: "",
      middleName: "",
      lastName: "",
      dob: "",
      gender: "Male",
      photo: "",
    },
    communication: {
      email: "",
      telephone: "",
      whatsapp: "",
      mobile: "",
      address: "",
      city: "",
      zipcode: "",
      country: "IN",
      socialLinks: ["", "", ""],
    },
    organization: {
      organizationName: "",
      organizationType: "Private Enterprise",
      organizationAddress: "",
      organizationPhone: "",
      organizationEmail: "",
      aboutCompany: "",
      companyLogo: "",
    },
    workExperience: {
      experienceYears: 0,
      experienceMonths: 0,
    },
    interests: {
      speciesOfInterest: [],
      speciesOther: "",
      fieldOfWork: [],
      natureOfWork: [],
      natureOther: "",
    },
    educationDetails: "",
  };

  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    if (member) {
      setFormData({
        profileInfo: {
          title: member.profileInfo?.title || "NA",
          firstName: member.profileInfo?.firstName || "NA",
          middleName: member.profileInfo?.middleName || "NA",
          lastName: member.profileInfo?.lastName || "NA",
          dob: member.profileInfo?.dob
            ? new Date(member.profileInfo.dob).toISOString().split("T")[0]
            : "NA",
          gender: member.profileInfo?.gender || "NA",
          photo: member.profileInfo?.photo || "NA",
        },
        communication: {
          email: member.communication?.email || "NA",
          telephone: member.communication?.telephone || "NA",
          whatsapp: member.communication?.whatsapp || "NA",
          mobile: member.communication?.mobile || "NA",
          address: member.communication?.address || "NA",
          city: member.communication?.city || "NA",
          zipcode: member.communication?.zipcode || "NA",
          country: member.communication?.country || "NA",
          socialLinks: [
            member.communication?.socialLinks?.[0] || "NA",
            member.communication?.socialLinks?.[1] || "NA",
            member.communication?.socialLinks?.[2] || "NA",
          ],
        },
        organization: {
          organizationName: member.organization?.organizationName || "NA",
          organizationType: member.organization?.organizationType || "NA",
          organizationAddress: member.organization?.organizationAddress || "NA",
          organizationPhone: member.organization?.organizationPhone || "NA",
          organizationEmail: member.organization?.organizationEmail || "NA",
          aboutCompany: member.organization?.aboutCompany || "NA",
          companyLogo: member.organization?.companyLogo || "NA",
        },
        workExperience: {
          experienceYears: member.workExperience?.experienceYears || 0,
          experienceMonths: member.workExperience?.experienceMonths || 0,
        },
        interests: {
          speciesOfInterest: member.interests?.speciesOfInterest || [],
          speciesOther: member.interests?.speciesOther || "NA",
          fieldOfWork: member.interests?.fieldOfWork || [],
          natureOfWork: member.interests?.natureOfWork || [],
          natureOther: member.interests?.natureOther || "NA",
        },
        educationDetails: member.educationDetails || "NA",
      });
    }
  }, [member]);

  const personalinformation = [
    { icon: "fa-regular fa-user", content: formData.profileInfo.gender },
    {
      icon: "fa-regular fa-calendar",
      content: formatDate(formData.profileInfo.dob),
    },
    { icon: "fa-regular fa-mobile", content: formData.communication.mobile },
    { icon: "fab fa-whatsapp", content: formData.communication.whatsapp },
    {
      icon: "fa-regular fa-phone-alt",
      content: formData.communication.telephone || "N/A",
    },
    { icon: "fa-regular fa-envelope", content: formData.communication.email },
    {
      icon: "fa-regular fa-map-marker-alt",
      content: formData.communication.address,
    },
    {
      icon: getSocialIcon(formData.communication.socialLinks[0]),
      content: formData.communication.socialLinks[0] || "N/A",
    },
    {
      icon: getSocialIcon(formData.communication.socialLinks[1]),
      content: formData.communication.socialLinks[1] || "N/A",
    },
    {
      icon: getSocialIcon(formData.communication.socialLinks[2]),
      content: formData.communication.socialLinks[2] || "N/A",
    },
  ];

  const organizationInfo = [
    { label: "Name", content: formData.organization.organizationName },
    { label: "Type", content: formData.organization.organizationType },
    { label: "Address", content: formData.organization.organizationAddress },
    { label: "Phone", content: formData.organization.organizationPhone },
    { label: "Email", content: formData.organization.organizationEmail },
    { label: "About Company", content: formData.organization.aboutCompany },
  ];

  const educationinformationareaofinteres = [
    {
      speciesOfInterest: formData.interests.speciesOfInterest,
      fieldOfWork: formData.interests.fieldOfWork,
      natureOfWork: formData.interests.natureOfWork,
      educationDetails: formData.educationDetails,
      experience: formData.workExperience.experienceYears?.toString() || "0",
    },
  ];

  const half = Math.ceil(personalinformation.length / 2);
  const firstHalf = personalinformation.slice(0, half);
  const secondHalf = personalinformation.slice(half);

  const fullName = `${formData.profileInfo.title} ${
    formData.profileInfo.firstName
  } ${
    formData.profileInfo.middleName === "NA"
      ? ""
      : formData.profileInfo.middleName
  } ${formData.profileInfo.lastName}`;

  return (
    <main>
      <Breadcrumb title="Member Details" />
      <div className="it-teacher-details-area pt-50 pb-50">
        <div className="container">
          <div className="it-teacher-details-wrap">
            <Tabs>
              <div className="row">
                <div className="col-xl-3 col-lg-3">
                  <div className="it-teacher-details-left">
                    <div className="it-teacher-details-left-thumb ">
                      <img
                        className="rounded-5 h-[300px] object-cover"
                        src={formData.profileInfo.photo || Men}
                        alt="Member"
                        onError={(e) => {
                          e.target.src = Men;
                        }}
                      />
                    </div>
                    <div className="it-teacher-details-left-social text-center pb-0">
                      <h5 style={{ color: "#704fe6" }}>{fullName}</h5>
                      <h6>{member?.membershipId || "N/A"}</h6>
                      <p>{member?.memberDesignation?.name || "N/A"}</p>
                    </div>
                  </div>
                </div>

                <div className="col-xl-9 col-lg-9">
                  <TabPanel>
                    <div className="it-teacher-details-right">
                      <div className="it-teacher-details-right-content">
                        <h5 className="mb-20" style={{ color: "#0b72ba" }}>
                          Personal Information
                        </h5>
                        <div className="row">
                          <div className="col-xl-4 col-lg-4 col-md-4">
                            <div className="it-teacher-details-left-info mb-0">
                              <ul>
                                {firstHalf.map(
                                  (item, index) =>
                                    item.content && (
                                      <li key={index}>
                                        <i
                                          className={item.icon}
                                          style={{ color: "#0e2a46" }}
                                        ></i>
                                        {item.content.startsWith("http") ? (
                                          <a
                                            href={item.content}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            {item.content}
                                          </a>
                                        ) : (
                                          <a>{item.content}</a>
                                        )}
                                      </li>
                                    )
                                )}
                              </ul>
                            </div>
                          </div>

                          <div className="col-xl-6 col-lg-6 col-md-6">
                            <div className="it-teacher-details-left-info">
                              <ul>
                                {secondHalf.map(
                                  (item, index) =>
                                    item.content && (
                                      <li key={index}>
                                        <i
                                          className={item.icon}
                                          style={{ color: "#0e2a46" }}
                                        ></i>
                                        {item.content.startsWith("http") ? (
                                          <a
                                            href={item.content}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                          >
                                            {item.content}
                                          </a>
                                        ) : (
                                          <a>{item.content}</a>
                                        )}
                                      </li>
                                    )
                                )}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="it-teacher-details-right-content mb-4">
                        <h5 className="mb-5 text-xl font-semibold text-[#0b72ba]">
                          Organizational Details
                        </h5>
                        <div className="rounded-lg border border-gray-200 bg-white p-6 shadow-sm">
                          <div className="flex flex-col items-center md:flex-row md:items-center md:space-x-6">
                            <div className="mb-4 flex-shrink-0 md:mb-0">
                              <img
                                className="h-48 w-48 rounded-full object-cover shadow-md"
                                src={
                                  formData.organization.companyLogo || defualt
                                }
                                alt="Organization"
                                onError={(e) => {
                                  e.target.src = defualt;
                                }}
                              />
                            </div>

                            <div className="w-full space-y-3">
                              {organizationInfo.map((item, index) => (
                                <div
                                  key={index}
                                  className="flex items-baseline"
                                >
                                  <div className="flex-shrink-0 pt-1">
                                    {item.label === "Name" && (
                                      <i className="fas fa-building mr-3 text-gray-500"></i>
                                    )}
                                    {item.label === "Type" && (
                                      <i className="fas fa-briefcase mr-3 text-gray-500"></i>
                                    )}
                                    {item.label === "Address" && (
                                      <i className="fas fa-map-marker-alt mr-3 text-gray-500"></i>
                                    )}
                                    {item.label === "Phone" && (
                                      <i className="fas fa-phone-alt mr-3 text-gray-500"></i>
                                    )}
                                    {item.label === "Email" && (
                                      <i className="fas fa-envelope mr-3 text-gray-500"></i>
                                    )}
                                    {item.label === "About Company" && (
                                      <i className="fas fa-info-circle mr-3 text-gray-500"></i>
                                    )}
                                  </div>
                                  <div className="min-w-0 flex-1">
                                    <p className="text-sm font-medium text-gray-900">
                                      {item.label}
                                    </p>
                                    <p className="text-sm text-gray-600">
                                      {item.content || (
                                        <span className="italic text-gray-400">
                                          Not provided
                                        </span>
                                      )}
                                    </p>
                                  </div>
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="it-teacher-details-right-content mb-40">
                        <h5 className="mb-20" style={{ color: "#0b72ba" }}>
                          Education Information & Area Of Interest
                        </h5>
                        <div className="row">
                          <div className="col-xl-12 col-lg-12 col-md-12">
                            <div className="postbox__details-tag mb-2">
                              <>
                                <span>Species of Interest</span>
                                <div>
                                  {educationinformationareaofinteres[0].speciesOfInterest.map(
                                    (tag, index) => (
                                      <a href="#" key={index}>
                                        {tag}
                                      </a>
                                    )
                                  )}
                                </div>
                              </>
                            </div>
                            <div className="postbox__details-tag mb-2">
                              <>
                                <span>Field of Work</span>
                                <div>
                                  {educationinformationareaofinteres[0].fieldOfWork.map(
                                    (tag, index) => (
                                      <a href="#" key={index}>
                                        {tag}
                                      </a>
                                    )
                                  )}
                                </div>
                              </>
                            </div>
                            <div className="postbox__details-tag mb-2">
                              <>
                                <span>Nature of Work</span>
                                <div>
                                  {educationinformationareaofinteres[0].natureOfWork.map(
                                    (tag, index) => (
                                      <a href="#" key={index}>
                                        {tag}
                                      </a>
                                    )
                                  )}
                                </div>
                              </>
                            </div>
                            <div className="postbox__details-tag mb-2">
                              <span>Education Details</span>
                              <p>{formData.educationDetails}</p>
                            </div>
                            <div className="postbox__details-tag mb-2">
                              <span>Work Experience in Aquaculture</span>
                              <div className="it-progress-bar-item">
                                <label>
                                  {formData.workExperience.experienceYears || 0}
                                </label>
                                <SingleProgress
                                  progress={
                                    formData.workExperience.experienceYears || 0
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {rolesData.length > 0 && (
                        <div className="it-teacher-details-right-content">
                          <h5 className="mb-20" style={{ color: "#0b72ba" }}>
                            Leadership Roles in SAP
                          </h5>
                          <div className="row">
                            <div className="col-xl-12 col-lg-12 col-md-12">
                              <div className="overflow-x-auto">
                                <table
                                  className="table-bordered"
                                  style={{ width: "100%" }}
                                >
                                  <thead style={{ backgroundColor: "#17254e" }}>
                                    <tr>
                                      <th
                                        style={{
                                          padding: "10px",
                                          textAlign: "left",
                                          color: "white",
                                        }}
                                      >
                                        S.NO
                                      </th>
                                      <th
                                        style={{
                                          padding: "10px",
                                          textAlign: "left",
                                          color: "white",
                                        }}
                                      >
                                        ROLE
                                      </th>
                                      <th
                                        style={{
                                          padding: "10px",
                                          textAlign: "left",
                                          color: "white",
                                        }}
                                      >
                                        PERIOD
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {rolesData.map((item, index) => (
                                      <tr key={item.sno}>
                                        <td style={{ padding: "10px" }}>
                                          {item.sno}
                                        </td>
                                        <td style={{ padding: "10px" }}>
                                          {item.role}
                                        </td>
                                        <td style={{ padding: "10px" }}>
                                          {item.period}
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </TabPanel>
                </div>
              </div>
            </Tabs>
          </div>
        </div>
      </div>
    </main>
  );
};

export default MemberProfileCardMain;
